import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { BooksIcon } from "@phosphor-icons/react";

export const KbDialog = ({ open, onOpenChange }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (open) api.get("/kb").then(({ data }) => setItems(data)).catch(() => {});
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="kb-dialog" className="max-w-2xl bg-zinc-950 border-zinc-800 text-zinc-200">
        <DialogHeader>
          <DialogTitle className="font-head flex items-center gap-2">
            <BooksIcon className="h-5 w-5 text-cyan-400" /> Vendor knowledge base
          </DialogTitle>
        </DialogHeader>
        <p className="text-xs text-zinc-500 -mt-2">
          These grounding references are injected into the AI prompt and back the template engine.
        </p>
        <div className="max-h-[60vh] overflow-y-auto space-y-3 pr-1">
          {items.map((a) => (
            <div key={a.id} data-testid={`kb-item-${a.id}`} className="rounded-sm border border-zinc-800 bg-zinc-900/50 p-3">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="font-mono text-[10px] uppercase tracking-wider text-cyan-400 border border-cyan-500/30 rounded-sm px-1.5 py-0.5 bg-cyan-500/10">
                  {a.vendor}
                </span>
                <h4 className="text-sm font-medium text-zinc-100">{a.title}</h4>
              </div>
              <p className="text-xs text-zinc-400 leading-relaxed">{a.body}</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
